module.exports = __webpack_public_path__ + "static/media/404-header.7ec04de3.svg";